import { gql, useMutation } from '@apollo/client';
import { SmsSenderMutationActionResult } from '../types';

const editSmsSenderMutation = gql`
  mutation editSmsSender($id: Long!, $fields: SmsSenderFieldsInput!) {
    updateSmsSender(id: $id, fields: $fields) {
      success {
        name
      }
      failure {
        message
      }
    }
  }
`;

type UseEditSmsSenderProps = {
  onCompleted: ({ updateSmsSender }: { updateSmsSender: SmsSenderMutationActionResult }) => void;
  onError: ({ message }: { message: string }) => void;
};

export const useEditSmsSender = ({ onCompleted, onError }: UseEditSmsSenderProps) => {
  const [editSmsSender, { data, loading, error }] = useMutation(editSmsSenderMutation, {
    onCompleted: (response) => {
      const { failure = [], success } = response.updateSmsSender;

      if (success) {
        return onCompleted(response);
      }

      const errorMessage = failure.map(({ message }: { message: string }) => message).join('. ');
      return onError({ message: errorMessage });
    },
    onError,
  });

  return {
    editSmsSender,
    data,
    loading,
    error,
  };
};
